import { render, staticRenderFns } from "./terms_conditions.vue?vue&type=template&id=29a13fa4&scoped=true&"
import script from "./terms_conditions.vue?vue&type=script&lang=js&"
export * from "./terms_conditions.vue?vue&type=script&lang=js&"
import style0 from "./terms_conditions.vue?vue&type=style&index=0&id=29a13fa4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29a13fa4",
  null
  
)

export default component.exports